import React from 'react';
import { RecruitmentOverview } from '@/Models/RecruitmentOverview';
import UIStrings from '@/Utils/UIStrings';
import DateTimeCaption from './components/DateTimeCaption';

interface RecruitmentListItemFooterProps {
    recruitment: RecruitmentOverview;
}

const RecruitmentListItemFooter = ({ recruitment }: RecruitmentListItemFooterProps) => {
    const { createdAt, closedAt } = recruitment;

    return (
        <div className="flex flex-row items-center justify-end gap-4">
            <DateTimeCaption label={UIStrings.Created} dateAt={createdAt} />
            <DateTimeCaption label={UIStrings.Closed} dateAt={closedAt} />
        </div>
    );
};

export default RecruitmentListItemFooter;
